import m from "mithril";
import "./checkmark.scss";

const PREDEFINED_SIZE_MAP = {
	small: "16px",
	medium: "24px",
	large: "52px",
	xLarge: "72px",
	xxLarge: "96px",
};

export default function Checkmark(size = "xxLarge", color = "#4cd137") {
	const computedSize = PREDEFINED_SIZE_MAP[size] || size;
	const style = {width: computedSize, height: computedSize};
	if (color) {
		style["--checkmark-fill-color"] = color;
	}

	return m("svg", {class: "checkmark", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 52 52", style}, [
		m("circle", {class: "checkmark__circle", cx: "26", cy: "26", r: "25", fill: "none"}),
		m("path", {class: "checkmark__check", fill: "none", d: "M14.1 27.2l7.1 7.2 16.7-16.8"}),
	]);
}
